export default __webpack_public_path__ + "static/media/CustomerService.720c7d21.svg";